import { ErrorData } from 'types/embedded/error';

export const getMessageFromErrorBody = (body: ErrorData | null): string | undefined =>
  body?.detail || body?.errors?.[0]?.title;
